module.exports = ol.format.GeoJSON;